import { render, staticRenderFns } from "./view-projects.vue?vue&type=template&id=c276f0a8&scoped=true&"
import script from "./view-projects.vue?vue&type=script&lang=js&"
export * from "./view-projects.vue?vue&type=script&lang=js&"
import style0 from "./view-projects.vue?vue&type=style&index=0&id=c276f0a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c276f0a8",
  null
  
)

export default component.exports